import React from "react";

import { formatCurrency } from "helpers/formatCurrency";

import "./_style.scss";
import CurrencyChip from "components/CurrencyChip/CurrencyChip";
import TextTranslator from "components/TranslateText/TextTranslator";

export const createProcessingFee = (data, i, formProps, overrides = {}) => {
  const {
    values: {
      feeAmount,
    },
  } = formProps;

  const feeStructure = data.feeStructure;
  const currency = overrides.currency || feeStructure.currency;
  const currencySymbol = overrides.currencySymbol || feeStructure.currencySymbol;

  return (
    <div data-test="donation-form-fee" className="donation-form__line-item --fee donation-fee__container" key={i}>
      <input type="hidden" name="feeAmount" value={feeAmount ?? ""} />
      <span className="donation-form__line-item-label">
        <TextTranslator>
          Payment processing fees:
        </TextTranslator>
      </span>
      <span className="donation-form__line-item-value" data-testid="donation-processing-fee">
        {currency && (
          <CurrencyChip currency={currency.toUpperCase()} size="small" hasMargin />
        )}
        { formatCurrency(feeAmount, { currencySymbol }, false) }
      </span>
    </div>
  );
};
